// i18n setup for Career Compass.
//
// Detection priority (highest to lowest):
//   1. localStorage 'compass_language' (user's explicit override from the
//      avatar menu toggle)
//   2. navigator.language (browser locale — pt-BR → pt, anything else → en)
//   3. Fallback to 'en'
//
// Only two locales for V1: en (default) and pt (Brazilian Portuguese).
// More can be added by dropping a new file under locales/ and registering
// it below.

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import pt from './locales/pt.json';

const SUPPORTED = ['en', 'pt'];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      pt: { translation: pt },
    },
    fallbackLng: 'en',
    supportedLngs: SUPPORTED,
    // Match a region tag like "pt-BR" to its base "pt" so we don't have to
    // ship pt-BR + pt-PT separately. Same for en-US/en-GB.
    load: 'languageOnly',
    interpolation: {
      escapeValue: false, // React already escapes output by default
    },
    detection: {
      // Order matters — first hit wins.
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'compass_language',
      caches: ['localStorage'],
    },
    react: {
      // Allow children that contain <strong> etc. to render as React nodes
      // when used with <Trans> instead of t().
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'em'],
    },
  });

export default i18n;
